<ins class="adsbygoogle" :data-ad-client="adClient" :data-ad-slot="adSlot" :data-ad-format="adFormat" :style="adStyle"></ins>